export function getRouteWithReturnUrl(
	baseRoute: string,
	returnUrl: string | null
) {
	if (returnUrl) {
		return `${baseRoute}${returnUrl}`;
	}

	return baseRoute;
}
